import * as React from "react"

const SvgComponent = ({fill}) => (
  <svg
    width={20}
    height={20}
    fill="none"
  >
    <path
      d="M8.042 0H.905C.4 0 0 .4 0 .905v7.137c0 .505.4.905.905.905h7.137c.505 0 .905-.4.905-.905V.905C8.947.4 8.547 0 8.042 0ZM19.095 0h-7.137c-.505 0-.905.4-.905.905v7.137c0 .505.4.905.905.905h7.137c.505 0 .905-.4.905-.905V.905C20 .4 19.6 0 19.095 0ZM8.042 11.053H.905c-.505 0-.905.4-.905.905v7.137C0 19.6.4 20 .905 20h7.137c.505 0 .905-.4.905-.905v-7.137c0-.505-.4-.905-.905-.905ZM19.095 11.053h-7.137c-.505 0-.905.4-.905.905v7.137c0 .505.4.905.905.905h7.137c.505 0 .905-.4.905-.905v-7.137c0-.505-.4-.905-.905-.905Z"
    //   fill="#636F7C"
      fill={fill}
    />
  </svg>
)

export default SvgComponent